<template>
	<sf-modal-layout size="xl" :title="getMessage_(screen.menuTitle)" ref="modal" :show="show_" :closeModal="closeModal">
		<comm-cd-desc-table :scrId="scrId" />
		<!-- <template v-slot:footer>
			<sf-button
				v-if="isButton_(scrId,'CD')"
				v-show="disabled"
				line
				color="error"
				type="primary"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000554'),
							buttons: [{ title: getMessage_('SWCC000280'), clickFn: removeProcess }]
						})
				"
				>{{ getMessage_('SWCC000280') }}</sf-button
			>
			<sf-button line :onClick="closeModal">{{ getMessage_('SWCC000243') }}</sf-button>
			<sf-button
				v-if="isButton_(scrId,'AD')"
				v-show="!disabled"
				type="primary"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000555'),
							buttons: [{ title: getMessage_('SWCC000245'), clickFn: registerProcess }]
						})
				"
				>{{ getMessage_('SWCC000245') }}</sf-button
			>
			<sf-button
				v-if="isButton_(scrId,'AD')"
				v-show="disabled"
				type="primary"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000553'),
							buttons: [{ title: getMessage_('SWCC000279'), clickFn: modifyProcess }]
						})
				"
				>{{ getMessage_('SWCC000279') }}</sf-button
			>
		</template> -->
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/CommonCode/store/helpers';
import { CommCdDescTable } from '@common/CommonCode/Content/Table';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	components: {
		CommCdDescTable
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		closeModal() {
			this.SET({
				key: 'commCdDescModal',
				value: {
					show: false,
					selectedRow: {}
				}
			});
		}
	}
};
</script>

<style></style>
